import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Protokoll } from "src/types/ProtokollType";
import { portalApiClient } from "../apiClient";
import { queryKeys } from "../queryKeys";
import { useParams } from "react-router-dom";
import { apiUrls } from "src/consts/ApiUrls";

export function useCreateReport() {
  const queryClient = useQueryClient();
  const { companyId } = useParams();
  const mutation = useMutation({
    mutationFn: async (report: Protokoll) => {
      const response = await portalApiClient.post<Protokoll>(
        apiUrls.reports.url(),
        report
      );
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.reports(companyId) });
    },
    mutationKey: queryKeys.reports(companyId),
  });

  return mutation;
}
